var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nf"},[_c('div',{staticClass:"nf__container"},[_c('img',{attrs:{"src":_vm.img,"alt":"404 not found"}}),_vm._v(" "),_c('p',{staticClass:"nf__tips"},[_vm._v("抱歉，当前页面不可用！")])])])}
var staticRenderFns = []

export { render, staticRenderFns }